import { Background } from "@client/component";
import React, { ReactNode } from "react";
import { TSubPlayProps } from "../interface";
import { MsgHistory } from "./MsgHistory";
import { ISubPlayConfig, SubPlay } from "./SubPlay";

export * from "./SubPlay";

export function BasePlay({ children }: { children: ReactNode }) {
  return (
    <>
      <Background />
      <MsgHistory />
      {children}
    </>
  );
}

export function buildSubView(config: ISubPlayConfig) {
  const { namespace, label } = config;
  return {
    namespace,
    label,
    Play: (props: TSubPlayProps) => <SubPlay key={props.game.id} {...props} config={config} />,
  };
}
